import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

/**
 * v7 `.home-section-head` — gold kicker, title, one-line description and an
 * optional trailing action.
 */
const HomeSectionHead = ({ kicker, title, description, compact, children }) => (
  <div
    className={classNames('experience-home-section-head', {
      compact,
    })}>
    <div>
      {kicker ? <span className='experience-home-kicker'>{kicker}</span> : null}
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
    </div>
    {children}
  </div>
)

HomeSectionHead.propTypes = {
  kicker: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  compact: PropTypes.bool,
  children: PropTypes.node,
}

export default HomeSectionHead
